import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ChargingHistoryClockIcon = ({ primaryColor = '#414042', strokeColor = '#414042', size, style, secondaryColor, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 11.3 11.3' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M6.75,6.75s-.08.05-.13.05-.09-.02-.13-.05l-.97-.97s-.02-.02-.02-.03c0,0,0-.02-.02-.03,0,0,0-.02,0-.04v-2.24c0-.1.08-.18.18-.18s.18.08.18.18v2.13l.92.92c.06.07.06.18,0,.26M5.83,8.76v-.18c0-.1-.08-.18-.18-.18s-.18.08-.18.18v.18c-1.58-.09-2.84-1.36-2.93-2.93h.18c.1,0,.18-.08.18-.18s-.08-.18-.18-.18h-.18c.09-1.58,1.36-2.84,2.93-2.93v.18c0,.1.08.18.18.18s.18-.08.18-.18v-.18c1.58.09,2.84,1.36,2.93,2.93h-.18c-.1,0-.18.08-.18.18s.08.18.18.18h.18c-.09,1.58-1.35,2.84-2.93,2.93M5.65,2.16c-1.93,0-3.49,1.56-3.49,3.49s1.56,3.49,3.49,3.49,3.49-1.56,3.49-3.49-1.56-3.49-3.49-3.49'
        />
        <circle cx='5.65' cy='5.65' r='5.48' fill='none' stroke={strokeColor} strokeWidth='0.34' />
    </SvgIcon>
);

export default ChargingHistoryClockIcon;
